// File: /src/components/dashboard/FinanceOverviewCard.js

import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { FaDollarSign } from 'react-icons/fa';

const FinanceOverviewCard = ({ financeSummary }) => {
	const { revenue, expense, overdue, net } = useMemo(() => {
		const totalIncome = Number(financeSummary.totalIncome) || 0;
		const totalReceived = Number(financeSummary.totalReceived) || 0;
		const totalExpense = Number(financeSummary.totalExpense) || 0;
		const totalOverdue = Number(financeSummary.totalOverdue) || 0;
		const totalRevenue = totalIncome + totalReceived;
		const netTotal =
			typeof financeSummary.netTotal === 'number'
				? financeSummary.netTotal
				: totalRevenue - (totalExpense + totalOverdue);

		return {
			revenue: totalRevenue,
			expense: totalExpense,
			overdue: totalOverdue,
			net: netTotal,
		};
	}, [financeSummary]);

	const formatCurrency = (value) =>
		value.toLocaleString('pt-BR', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});

	return (
		<div className="card">
			<div className="card-icon">
				<FaDollarSign size={16} />
			</div>
			<h2>Financeiro</h2>
			<Link to="/finance">
				<button>Ver Resumo Financeiro</button>
			</Link>
			<p>Receitas + Faturas Pagas: R$ {formatCurrency(revenue)}</p>
			<p>Despesas: R$ {formatCurrency(expense)}</p>
			<p>Faturas Atrasadas: R$ {formatCurrency(overdue)}</p>
			<p>Saldo Efetivo: R$ {formatCurrency(net)}</p>
		</div>
	);
};

export default FinanceOverviewCard;
